import React from 'react';
import { Box, Skeleton } from '@mui/material';

const InlineLoader: React.FC<{ rows?: number }> = ({ rows = 3 }) => {
  return (
    <Box sx={{ p: 1 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height={24} sx={{ mb: 1 }} />
      ))}
    </Box>
  );
};

export default InlineLoader;
